/**
 * API service for making requests to the backend
 */
import axios from 'axios';

// Remove runtimeConfig declaration
// declare global {
//   interface Window {
//     runtimeConfig?: {
//       apiUrl?: string;
//       socketUrl?: string;
//     };
//   }
// }

// Create axios instance with default configuration
// Read directly from build-time environment variables
const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

if (!process.env.REACT_APP_API_URL) {
  console.warn('REACT_APP_API_URL is not set. Falling back to default: ', apiBaseUrl);
}

const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercept requests to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // console.log(`[API Interceptor] Requesting: ${config.url}`);
    if (token) {
      // Log only first/last few chars for security
      // const tokenSnippet = token.length > 15 ? `${token.substring(0, 7)}...${token.substring(token.length - 7)}` : token;
      // console.log(`[API Interceptor] Found token: ${tokenSnippet}. Attaching to headers.`);
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('[API Interceptor] Authorization header set:', config.headers.Authorization);
    } else {
      // console.log('[API Interceptor] No token found in localStorage.');
    }
    return config;
  },
  (error) => {
    // console.error('[API Interceptor] Request error:', error);
    return Promise.reject(error);
  }
);

// Intercept responses to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (expired token, etc.)
    if (error.response && error.response.status === 401) {
      // Clear token and let AuthContext/ProtectedRoute handle state/redirect
      localStorage.removeItem('token');
      // window.location.href = '/login'; // Avoid hard refresh
      console.warn('API request Unauthorized (401). Token removed.'); // Keep this warning
    }
    return Promise.reject(error);
  }
);

export default api;
